export default function TestimonyPreview() {
  return (
    <section className="w-full py-20 bg-white">
      <div className="max-w-6xl mx-auto text-center px-4" data-aos="fade-up">

        <h2 className="text-3xl font-bold text-[#1A1F2B]">Testimonies</h2>
        <p className="text-gray-700 mt-3">God is moving in people's lives</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-14">

          <div className="p-6 bg-[#F5E9D8] rounded-xl shadow" data-aos="fade-up">
            <p className="text-[#1A1F2B] italic">
            “Through Jesus Christ, I found peace, protection, and a new life.”
            </p>
            <h4 className="font-semibold mt-4">Sunaina Chaudhary (Delhi)</h4>
          </div>

          <div className="p-6 bg-[#F5E9D8] rounded-xl shadow" data-aos="fade-up">
            <p className="text-[#1A1F2B] italic">
              “प्रभु ने मेरे परिवार को चंगाई और आशीषों से भर दिया।”
            </p>
            <h4 className="font-semibold mt-4">Reena Shrivastava (India)</h4>
          </div>

          <div className="p-6 bg-[#F5E9D8] rounded-xl shadow" data-aos="fade-up">
            <p className="text-[#1A1F2B] italic">
          “यीशु मसीह ने मेरे जीवन और परिवार को पूरी तरह बदल दिया।”
            </p>
            <h4 className="font-semibold mt-4">Ramkumar Patel (Ex-Army Subedar)</h4>
          </div>

        </div>

      </div>
    </section>
  );
}
